const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  picArr: state => state.app.picArr,
  categPicArr: state => state.app.categPicArr,
  brandBigpicId: state => state.app.brandBigpicId,
  brandLogId: state => state.app.brandLogId,
  brandCategId: state => state.app.brandCategId,
  richPicId: state => state.app.richPicId
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js